export interface SampleDocument {
  id: string;
  title: string;
  subtitle: string;
  filename: string;
  publicPath: string;
}

export const SAMPLE_DOCUMENTS: SampleDocument[] = [
  {
    id: '1',
    title: 'Tax Return.pdf',
    subtitle: 'See client-aware tax document naming',
    filename: 'Tax-Return.pdf',
    publicPath: '/samples/Tax-Return.pdf',
  },
  {
    id: '2',
    title: 'Bank Statement.pdf',
    subtitle: 'See account and period detection',
    filename: 'Bank-Statement.pdf',
    publicPath: '/samples/Bank-Statement.pdf',
  },
  {
    id: '3',
    title: 'Invoice.pdf',
    subtitle: 'See vendor and date extraction',
    filename: 'Invoice.pdf',
    publicPath: '/samples/Invoice.pdf',
  },
];

export const FILE_UPLOAD_ACCEPT =
  'application/pdf,.pdf,image/png,.png,image/jpeg,.jpg,.jpeg';

export const AI_UPLOAD_ERROR =
  "This file type isn't supported for document analysis. Please upload a PDF, PNG, or JPEG under 100 MB.";

const MAX_UPLOAD_BYTES = 100 * 1024 * 1024;
const ALLOWED_EXT = /\.(pdf|png|jpe?g)$/i;
const ALLOWED_MIME = /^(application\/pdf|image\/(png|jpeg))$/;

/** Onboarding showcase: PDF, PNG, JPEG only (max 100 MB). Intentionally narrower than backend image/* for a simple demo path. */
export function isAiUploadAllowed(file: File): boolean {
  return (
    file.size > 0 &&
    file.size <= MAX_UPLOAD_BYTES &&
    ALLOWED_EXT.test(file.name) &&
    (!file.type || ALLOWED_MIME.test(file.type))
  );
}
